import './App.css';
import CustomeRoutes from './CustomRoutes';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  return (
    <div>
      <GoogleOAuthProvider clientId="81986630180-lta58cehdpf0b35s4cgesficcr7aluvg.apps.googleusercontent.com">
        <CustomeRoutes />
      </GoogleOAuthProvider>
    </div>
  );
}

export default App;
